import { emptyObj } from 'util/objects'
import { emptyArray } from 'util/arrays'
import { createSelector } from 'reselect'

export function selectBase(state) {
  return state.realtime || emptyObj
}

export const selectUnreadRoomIds = createSelector(
  selectBase,
  realtime => realtime.unreadRoomIds || emptyArray
)
